import React from 'react';
import './styles/index.css';
import AppRouter from './routes';

const App: React.FC = () => {
  return (
    <AppRouter />
  );
};

export default App;
